<template>
  <picture v-if="containsImage(imageNode)">
    <template v-if="hasBreakpoints && isResizerImage(img) && isResizableImage(imageNode)">
      <template v-for="(value, key) in SORTED_BREAKPOINTS" :key="key">
        <template v-if="breakpoints && breakpoints[key]">
          <source
            :media="`(min-width: ${value}px)`"
            :srcset="imageResizerPath(img, breakpoints[key].width, breakpoints[key].height, true)"
            type="image/webp"
          />
          <source
            :media="`(min-width: ${value}px)`"
            :srcset="imageResizerPath(img, breakpoints[key].width, breakpoints[key].height)"
            :type="imageResizerType(img)"
          />
        </template>
      </template>
    </template>

    <img
      :loading="loading ?? 'lazy'"
      :class="imgClass"
      :style="{
        imageRendering,
        objectPosition: `${objectPositionX ?? 50}% ${objectPositionY ?? 50}%`,
      }"
      :src="src"
      :alt="getImageAlt(imageNode)"
      :title="getImageTitle(imageNode)"
      :width="getImageWidth(img) ?? 400"
      :height="getImageHeight(img) ?? 300"
    />
  </picture>
</template>

<script setup>
import {
  containsImage,
  getImageTitle,
  getImageAlt,
  getImageWidth,
  getImageHeight,
  isResizerImage,
  isResizableImage,
  imageResizerType,
  imageResizerPath,
  imagePath,
} from "~/utils/helper/magnolia";
import { BREAKPOINTS } from "~/utils/helper/imaging";

const SORTED_BREAKPOINTS = Object.fromEntries(
  Object.entries(BREAKPOINTS).sort(([, a], [, b]) => b - a),
);

const { img, imgSrc, breakpoints } = defineProps([
  "img",
  "imgSrc",
  "breakpoints",
  "imgClass",
  "loading",
  "imageRendering",
  "objectPositionY",
  "objectPositionX",
]);

const imageNode = computed(() => {
  return img?.["damID"] ?? img;
});

const hasBreakpoints = computed(() => {
  return breakpoints && Object.keys(breakpoints).length > 0;
});

const src = computed(() => {
  return (
    imgSrc ||
    (isResizerImage(imageNode.value) && imageResizerPath(img, BREAKPOINTS.sm, 0)) ||
    imagePath(imageNode.value) ||
    `data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==`
  );
});
</script>
